import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import * as S from './EmptyBookmarksModal.styled';
import { Modal } from '@/components/UI/Modal';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { Button } from '@/components/UI/Button/Button';

interface EmptyBookmarksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EmptyBookmarksModal = ({
  isOpen,
  onClose,
}: EmptyBookmarksModalProps) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { isDesktop } = useBreakpoint();

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onClose();
  };

  const handleGoHome = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    router.push('/');
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={isDesktop ? 460 : 345}
      dataTestId="empty-bookmarks-modal"
    >
      <S.Body>
        <S.Content>
          <S.Title>
            {t('bookmark_collections.empty_bookmarks_modal_title')}
          </S.Title>
          <S.Description>
            {t('bookmark_collections.empty_bookmarks_modal_description')}
          </S.Description>
        </S.Content>

        <S.ButtonContainer>
          <Button
            isFullWidth
            borderRadius={14}
            onClick={handleClose}
            appearance="secondaryOutlined"
          >
            {t('bookmark_collections.empty_bookmarks_modal_cancel')}
          </Button>
          <Button
            isFullWidth
            borderRadius={14}
            onClick={handleGoHome}
            appearance="secondary"
          >
            {t('bookmark_collections.empty_bookmarks_modal_go_home')}
          </Button>
        </S.ButtonContainer>
      </S.Body>
    </Modal>
  );
};
